import React, { PureComponent } from "react";
import styled from "styled-components";

const UserUl = styled.ul`
  display: block;
  width: ${(props) => props.width || "33.33%"};
  padding: ${(props) => props.padding || "0 40px"};
  box-sizing: border-box;
`;
const UserOnlyText = styled.li`
  display: block;
  text-align: ${(props) => props.textAlign || "left"};
  padding-top: ${(props) => props.paddingTop || "18px"};
  color: ${(props) => props.color || "#666666"};
  border-bottom: ${(props) => props.border || "none"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "inherit"};
  line-height: 26px;
  ${({ theme }) => theme.media.mobile`
    line-height: 15px;
  font-size: 10px
    `}
`;
const UserSpan = styled.span`
  display: block;
  text-align: ${(props) => props.textAlign || "left"};
  padding-top: ${(props) => props.paddingTop || "0px"};
  color: ${(props) => props.color || "#666666"};
  border-bottom: ${(props) => props.border || "none"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "inherit"};
  margin: ${(props) => props.margin || "inherit"};
  position: ${(props) => props.position || "static"};
  ${({ theme }) => theme.media.mobile`
  font-size: 10px
    `}
`;

export class StoreAgreement2 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제2조 약관의 효력과 변경
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            이 약관에서 사용하는 용어의 정의는 다음과 같다. 본 조에 의하여
            정의되지 않은 이 약관상의 용어의 의미는 일반적인 거래관행에 따른다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            서비스란, 서비스가맹점이 구매 고객에게 상품 및 용역(이하 상품 등)과
            교환 가능한 포인트를 제공함으로써 고객의 랩포인트 가입을 유도하고,
            회사는 서비스가맹점이 매장을 효율적으로 운영할 수 있도록 고객정보에
            기반한 통계분석 및 마케팅 프로모션 등을 지원하는 서비스(관련
            부가서비스 포함)를 의미한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            서비스가맹점이란, 매장을 운영·관리할 권한이 있는 자로서 이 약관에
            따라 회사와 서비스 이용계약을 체결하는 당사자를 의미한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            매장이란, 서비스가맹점이 운영·관리하고 있는 사업체를 의미한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              4.
            </UserSpan>
            포인트란, 고객이 매장에서 상품 등을 구매할 경우 제공·적립되는
            마일리지로, 랩포인트 가입 고객은 적립한 포인트를 이용해 해당
            매장에서 회사와 서비스가맹점이 사전 협의한 범위 내의 상품 등을
            구매할 수 있다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              5.
            </UserSpan>
            쿠폰이란, 서비스가맹점이 랩포인트 가입 고객에게 마케팅을 목적으로
            지급하는 쿠폰을 의미하며, 고객은 쿠폰을 사용하여 해당 매장에서 상품
            등을 구매할 수 있다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement3 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제3조 약관의 명시와 설명 및 개정
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 이 약관의 내용과 상호 및 대표자 이름, 주소, 전화번호, 이메일,
            사업자등록번호, 개인정보관리책임자 등을 서비스가맹점이 쉽게 알 수
            있도록 앱 내에 게시한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사는 『전자상거래 등에서의 소비자보호에 관한 법률』, 『약관의 규제
            등에 관한 법률』, 『전자거래 기본법』, 『전자서명법』, 『정보통신망
            이용촉진 등에 관한 법률』, 『소비자기본법』 등 관련법령을 위배하지
            않는 범위에서 이 약관을 개정할 수 있다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행
            약관과 함께 앱의 초기화면에 공지하기로 한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              4.
            </UserSpan>
            제3항에 의해 변경된 약관은 관련 법령에 특별한 규정 기타 부득이한
            사유가 없는 한 그 적용일자 이전으로 소급하여 적용되지 아니한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              5.
            </UserSpan>
            제3항에 따라 공지된 적용일자 이후에 서비스가맹점이 명시적으로
            거부의사를 표명하지 않을 경우에는 개정된 약관에 동의하는 것으로
            간주하며, 변경된 약관에 동의하지 않는 서비스가맹점은 탈퇴를 요청할
            수 있다. 제3항의 조치에도 불구하고 약관의 개정 사실을 알지
            못함으로써 발생하는 서비스가맹점의 피해에 대하여 회사는 책임을 지지
            않는다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              6.
            </UserSpan>
            회사는 제공하는 서비스 내의 개별 서비스에 대한 별도의 약관 또는
            이용조건을 둘 수 있으며 개별 서비스에서 별도로 적용되는 약관에 대한
            동의는 서비스가맹점이 개별 서비스를 최초로 이용할 경우 별도의
            동의절차를 거치게 된다. 이 경우 개별 서비스에 대한 이용약관 등이 이
            약관에 우선한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              7.
            </UserSpan>
            이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는
            관련법령의 규정과 일반 상관례에 따른다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement4 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제4조 서비스 이용계약
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            서비스 이용계약이란, 본 약관에 따른 서비스의 제공 또는 이용을 위하여
            회사와 서비스가맹점이 체결하는 계약으로, 랩포인트 앱에
            가입/로그인하고 본 약관에 동의하는 것으로 성립된다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사는 다음 각 호에 해당하는 이용계약에 대해서는 가입을 취소할 수
            있다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                타인의 카드 가맹점 정보를 무단으로 도용했을 때
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                타인의 서비스 이용을 방해하거나 그 정보를 도용하는 등의 행위를
                했을 때
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  c.
                </UserSpan>
                이용자가 법령과 본 약관이 금지하는 행위를 하는 경우
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  d.
                </UserSpan>
                회사가 정한 이용신청조건이 미비되었을 때
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement5 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제5조 서비스의 제공 및 변경
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 다음 각 호와 같은 서비스를 제공하기로 한다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                포인트 제공 및 적립 지원 서비스
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                고객정보에 기반한 통계분석 등 고객관리 서비스
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  c.
                </UserSpan>
                맞춤형 마케팅 서비스
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  d.
                </UserSpan>
                이에 수반되는 기타 서비스 일체
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해
            제공할 서비스의 내용을 변경할 수 있다. 이 경우 변경된 서비스의
            내용을 명시하여 현재의 서비스의 내용을 게시한 곳에 즉시 공지한다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement6 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제6조 서비스의 중단
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 천재지변 또는 이에 준하는 불가항력, 정보통신설비의
            보수점검·교체, 고장, 통신의 두절 등의 사유가 발생한 경우에는
            서비스의 제공을 일시적으로 중단할 수 있다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사는 서비스가맹점이 본 약관의 내용에 위배되는 행동을 한경우,
            임의로 서비스 사용을 제한 및 중지할 수 있다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement7 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제7조 회사의 의무
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 회원 및 가맹점의 신상 정보를 본인의 승낙없이 타인에게 누설,
            배포하지 않습니다. 다만, 전기통신관련법등 관계법령에 의하여 국가기관
            등의 요구가 있는 경우에는 그러하지 아니한다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement8 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제8조 서비스가맹점의 의무
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            서비스가맹점은 랩포인트에 가입한 구매 고객에게 포인트 또는 쿠폰을
            제공함으로써 고객의 랩포인트 가입을 유도하고, 고객이 적립한 포인트
            또는 쿠폰을 이용하여 회사와 사전 협의한 바에 따라 매장 내 상품 등을
            구매할 수 있도록 하여야 한다. 포인트 또는 쿠폰의 제공에 따른 비용은
            서비스가맹점이 전액 부담하며, 회사는 서비스 제공 및 관리를 지원하는
            역할만을 담당한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            서비스가맹점은 서비스 이용계약에 따른 방법에 의하지 아니하고
            비정상적인 방법으로 서비스를 이용하거나 회사의 정보처리시스템에
            접근하는 행위를 하여서는 아니 된다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            서비스가맹점은 회원가입 시 요구되는 정보를 정확하게 제공해야 한다.
            또한 제공된 서비스가맹점의 정보가 정확하도록 유지, 갱신하여야 한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              4.
            </UserSpan>
            회원은 자신의 로그인 정보를 제3자에게 이용하게 해서는 안된다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              5.
            </UserSpan>
            서비스가맹점이 마케팅 목적으로 고객에게 메시지를 발송할 경우, 다음
            각호의 행위를 하여서는 아니 된다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                음란 또는 폭력적 메시지, 사행행위 유도, 청소년보호법에서
                규정하는 청소년유해매체물, 기타 공서양속에 반하는 정보를 전송,
                도달, 유포하는 행위
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                타인의 의사에 반하여 광고성 정보 및 유사한 내용을 지속적으로
                전송하는 행위
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  c.
                </UserSpan>
                타인의 지적재산권 등을 침해하는 행위
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  d.
                </UserSpan>
                범죄행위를 목적으로 하거나 범죄행위를 교사하는 행위
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  e.
                </UserSpan>
                선량한 풍속 또는 기타 사회질서를 해치는 행위
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  f.
                </UserSpan>
                서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의
                행위
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  g.
                </UserSpan>
                회사의 동의 없이 회사의 서비스를 이용하여 얻은 정보를 복사,
                복제, 변경, 번역, 출판, 방송 및 기타의 방법으로 사용하거나 이를
                타인에게 제공하는 행위
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  h.
                </UserSpan>
                불법 선거 운동을 하는 행위
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              6.
            </UserSpan>
            서비스가맹점은 회사 또는 제3자의 권리를 침해 또는 침해할 우려가
            있거나, 거래 질서를 위협하는 행위를 하여서는 아니된다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              7.
            </UserSpan>
            회사는 본 조를 위반한 서비스가맹점에 대하여 서비스 이용계약의 해제
            및 민∙형사상 법적 조치를 취할 수 있다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement9 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제9조 고객정보의 수집, 이용 및 처리
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            서비스를 통해 수집한 고객의 개인정보, 매장이용내역 등 일체의
            정보(이하 고객정보)에 대한 권리는 회사에게 귀속된다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사는 수집한 고객정보를 서비스가맹점이 마케팅, 고객분석 등에 이용할
            수 있도록 가공하여 제공하되, 고객의 개인정보(성명, 전화번호 등)는
            비식별화(마스킹)하여 제공하는 것을 원칙으로 한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            서비스가맹점은 회사가 전항에 따라 수집, 가공 및 비식별화 과정을
            완료하여 제공하는 고객정보만을 조회할 권한이 있으며, 회사가 수집한
            모든 고객정보의 열람 및 교부를 요청할 수는 없다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              4.
            </UserSpan>
            제3항에도 불구하고, 서비스가맹점이 고객으로부터 개인정보의
            제3자(서비스가맹점) 제공에 관한 동의를 징구한 경우, 서비스가맹점이
            회사에게 당해 고객의 개인정보를 요구할 수 있다. 단, 서비스가맹점은
            고객이 동의한 범위를 초과하여 고객정보를 이용할 수 없다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              5.
            </UserSpan>
            서비스가맹점은 본 약관과 무관하게 수집한 고객정보를 본건 서비스를
            통해 수집한 고객정보와 통합하여 처리할 수 없다. 단, 해당 고객정보의
            주체로부터 사전 동의를 구한 경우는 예외적으로 허용된다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              6.
            </UserSpan>
            서비스가맹점이 개인정보보호법 등 관련법령을 위반하여 고객정보를
            수집·이용·처리함으로써 회사 또는 제3자에게 손해를 입힌 경우,
            서비스가맹점은 자기의 책임과 비용으로 이를 배상하기로 한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              7.
            </UserSpan>
            서비스가맹점은 서비스 이용계약이 종료 또는 해지된 이후에는
            고객정보를 조회하거나 요구할 수 없다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement10 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제10조 개인정보보호
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 서비스 제공을 위하여 필요 최소한의 범위 내에서 개인정보를
            수집한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사는 개인정보를 수집하기 전 정보주체에게 그 목적을 고지하고 동의를
            받기로 한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            회사는 수집된 개인정보를 목적 외의 용도로 이용할 수 없으며, 새로운
            이용목적이 발생한 경우 또는 제3자에게 제공하는 경우에는 사전에
            정보주체에게 그 목적을 고지하고 동의를 받기로 한다. 다만, 관련
            법령에 달리 정함이 있는 경우에는 예외로 한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              4.
            </UserSpan>
            회사 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 처리목적을
            달성하거나 보관기간이 도과한 경우에는 당해 개인정보를 지체 없이
            파기하기로 한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              5.
            </UserSpan>
            회사는 개인정보의 수집·이용·처리에 관한 동의 거절 시 제한되는
            서비스를 구체적으로 명시하고, 필수 수집항목이 아닌 개인정보의
            수집·이용·처리에 관한 정보주체의 동의 거절을 이유로 회원가입 등
            서비스 제공을 제한하거나 거절하지 않는다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              6.
            </UserSpan>
            회사는 다음과 같은 경우에 법이 허용하는 범위 내에서 정보주체의
            개인정보를 제3자에게 제공할 수 있다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                수사기관이나 기타 정부기관으로부터 적법한 절차에 따른 정보제공을
                요청받은 경우
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                정보주체가 관련 법령을 위반하는 등의 부정행위를 확인하기 위해
                필요한 경우
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  c.
                </UserSpan>
                서비스 제공 또는 관리에 필요한 최소한의 개인정보(성명, 주소,
                전화번호)를 제공하여야 하는 경우
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  d.
                </UserSpan>
                서비스 이용이 종료된 이후에도 반품, 교환, 환불, 취소 등을 위하여
                필요한 경우
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  e.
                </UserSpan>
                기타 관련 법령에 의해 요구되는 경우
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              7.
            </UserSpan>
            기타 본 조에서 정하지 않은 사항은 회사의 개인정보처리방침에 따른다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement11 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제11조 손해배상
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사 또는 서비스가맹점 중 어느 일방이 본 약관에 정한 사항을 이행하지
            아니하거나 위반하여 상대방에게 손해를 입힌 경우, 위반당사자의 책임과
            비용으로 상대방이 입은 손해를 배상하기로 한다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement12 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제12조 회사의 면책
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할
            수 없는 경우에는 서비스 제공에 관한 책임이 면제된다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사는 서비스가맹점의 귀책사유로 인한 서비스 이용의 장애에 대하여
            책임을 지지 않는다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            회사는 서비스가맹점이 서비스를 이용하여 기대하는 수익을 상실한 것에
            대하여 책임을 지지 않으며, 그 밖의 서비스를 통하여 알게 된 정보를
            이용함에 따라 입은 손해에 대하여 책임을 지지 않는다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              4.
            </UserSpan>
            회사는 서비스가맹점이 게재한 정보, 자료, 사실의 신뢰도, 정확성 등
            내용에 관해서는 책임을 지지 않는다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              5.
            </UserSpan>
            회사는 서비스가맹점 간 또는 서비스가맹점과 제3자 상호 간에 본
            약관에서 정한 범위를 초과하여 서비스를 매개로 하여 거래 등을 한
            경우에는 책임이 면제된다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              6.
            </UserSpan>
            회사는 무료로 제공되는 서비스 이용과 관련하여 관련 법령에 특별한
            규정이 없는 한 책임을 지지 않는다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement13 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제13조 정보보호 및 비밀유지
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 서비스를 제공하는 과정에서 수집, 가공, 제공한 모든
            정보(고객정보 포함)에 대한 일체의 권리를 보유한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            서비스가맹점은 본 약관에 따른 서비스 및 이에 부수한 업무를 위한
            목적으로만 회사가 제공한 고객정보 등 정보를 이용할 수 있으며, 회사의
            사전 동의 없이 위 목적 외에 수령한 정보를 이용하여서는 아니 된다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            서비스가맹점은 서비스 이용과 관련하여 회사로부터 수령한 일체의
            정보를 서비스 이용계약이 종료됨과 동시에 회사에 반환하거나
            파기하여야 한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              4.
            </UserSpan>
            회사와 서비스가맹점은 본 약관에 따른 서비스와 관련하여 알게 된
            상대방의 영업비밀 또는 정보에 대하여 상대방의 사전 서면 동의가 없는
            한 제3자에게 이를 유출하거나 서비스 이용 이외의 목적으로
            이용하여서는 아니되며(이하 비밀유지의무), 비밀유지의무를 위반한
            당사자는 이에 따른 모든 법적 책임을 부담하기로 한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              5.
            </UserSpan>
            제4항에 따른 비밀유지의무는 서비스 이용계약의 종료일로부터 3년 간
            유효하다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              6.
            </UserSpan>
            회사 또는 서비스가맹점 중 어느 일방이 본 약관 및 서비스 이용에 관한
            사항을 제3자 또는 언론매체에 공개할 경우에는 반드시 상대방과 사전
            합의하여 일정, 공개내용, 정보수취인 등을 결정하여야 한다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement14 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제14조 권리, 의무의 양도금지
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            회사와 서비스가맹점은 상대방의 사전 서면동의 없이 이 약관상의 권리
            또는 의무의 전부 또는 일부를 제3자에게 양도, 이전, 증여하거나 이를
            담보로 제공할 수 없다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement15 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제15조 기타
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            이 약관에서 규정하지 않은 사항은 신의원칙에 따라 회사와
            서비스가맹점이 협의하여 결정하되, 협의되지 아니한 사항은 관계법령 및
            일반 거래 관행에 의한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            본 약관의 변경 또는 수정은 회사와 서비스가맹점이 서면으로 합의한
            바에 따른다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            본 약관에 대한 해석 및 분쟁은 대한민국의 법률을 적용하며, 소송이
            제기되는 경우에는 서울중앙지방법원을 전속관할로 한다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class StoreAgreement16 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          부칙
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>이 약관은 2022년 8월 31일부터 시행한다.</UserOnlyText>
        </UserUl>
      </div>
    );
  }
}
